module.exports = __webpack_public_path__ + "img/image (72).26ea3ad4.jpg";